import React, { Component } from 'react';

class Contact extends Component {
    render() {
        return (
          <section className="page contact">
            <div id="featuredImage" className="featuredImage bgContact"></div>
            <h1 className="title">Kontakt</h1>
            <p className="content">
              <b>ERB-Kauf GmbH</b> <br />
              Bennostraße 2 <br />
              13053 Berlin <br />
              Telefon  +49 30 34 64 98 700 <br />
              Fax  +49 30 34 64 98 750 <br />
              <a href="mailto:mail@erb-kauf.de" target="_blank" rel="noopener noreferrer">mail@erb-kauf.de</a> <br />
            </p>
          </section>
        );
    }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/pages/Contact.js